import { render, staticRenderFns } from "./ConfiguracaoSegmentos.vue?vue&type=template&id=9c9bdeb8&lang=pug"
import script from "./ConfiguracaoSegmentos.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoSegmentos.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracaoSegmentos.vue?vue&type=style&index=0&id=9c9bdeb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports